export const defaultCookieConfig: Cookies.CookieAttributes = {
  path: '/',
  // Maximum according to GDPR rules
  expires: 365,
  sameSite: 'strict',
  secure: process.env.NODE_ENV === 'production',
  // Use domain with dot in front so that Shopify Checkout can read the cookie
  domain: process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_VERCEL_ENV !== 'preview' ? process.env.NEXT_PUBLIC_COOKIE_DOMAIN || '.mrmarvis.com' : undefined,
}
